import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';
import {
  LayerGroup, LeafletEvent, Marker, GeoJSON, LatLng, Polyline,
} from 'leaflet';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import polyUtil from 'polyline-encoded';

export default class TrackLineLayerService extends LayerService {
  /*eslint-disable */
  onClick(e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void {
  }

  protected generatePolyLinesLayer = (trackLines: any): LayerGroup => {
    const layerGroup = new LayerGroup();

    let durationInSeconds = 0;
    const indexForTooltip = Math.round((trackLines.length - 2));
    const totalDurationInSeconds = trackLines.reduce((acc: any, leg: any) => acc + parseInt(leg.duration), 0);
    const totalDurationInMinutes = Math.floor(totalDurationInSeconds / 60);
        

    trackLines.map((leg: any, index: number) => {
      durationInSeconds += leg.duration;
      const {points}  = leg.legGeometry;
      const polylineCoordsArrays = polyUtil.decode(points);
      const polyline = new Polyline(polylineCoordsArrays, {
        color: '#1a73e8',
        weight: 6,
        opacity: 0.85,
        smoothFactor: 1,
      });

      // if (index == indexForTooltip) {
      //   polyline.bindTooltip(`<strong>${totalDurationInMinutes} min </strong>`, {
      //     permanent: true,
      //     className: 'tooltip-track',
      //   });
      // }
      layerGroup.addLayer(polyline);
    });

    return layerGroup;
  };

  redrawLayer = (): LayerGroup<any> => {
    const { trackLines } = store.state;

    return this.generatePolyLinesLayer(trackLines);
  };
}
